import {BaseApi} from './base-api';
import Vue from 'vue';

export class EmailApi extends BaseApi {
  static apiUri = 'emails';

  /** @return {Promise<EntityHttpResponse<EmailDto>>} */
  static getById (id) {
    return super.getById(id);
  }
}
